import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    OrganizationCloseStagePathParamsSchema,
    CloseStagePathParamsSchema,
    OrganizationCloseStageCreateSchema,
    OrganizationCloseStageUpdateSchema,
    OrganizationCloseStageChangePositionSchema,
} from "../schemas/organization-close-stage.schema";
import { OrganizationCloseStageSchema } from "../types/organizationCloseStage";

export {
    OrganizationCloseStageCreateSchema,
    OrganizationCloseStageUpdateSchema,
    OrganizationCloseStageChangePositionSchema,
};
export type {
    OrganizationCloseStageCreate,
    OrganizationCloseStageUpdate,
    OrganizationCloseStageChangePosition,
} from "../schemas/organization-close-stage.schema";

const c = initContract();

export const organizationCloseStageContract = c.router(
    {
        listOrganizationCloseStages: {
            method: "GET",
            path: "/organizations/:organizationId",
            pathParams: OrganizationCloseStagePathParamsSchema,
            responses: {
                200: z.object({
                    closeStages: z.array(OrganizationCloseStageSchema),
                }),
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        createOrganizationCloseStage: {
            method: "POST",
            path: "/organizations/:organizationId",
            pathParams: OrganizationCloseStagePathParamsSchema,
            body: OrganizationCloseStageCreateSchema,
            responses: {
                201: OrganizationCloseStageSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        updateOrganizationCloseStage: {
            method: "PATCH",
            path: "/organizations/:organizationId/:closeStageId",
            pathParams: OrganizationCloseStagePathParamsSchema.merge(
                CloseStagePathParamsSchema,
            ),
            body: OrganizationCloseStageUpdateSchema,
            responses: {
                200: OrganizationCloseStageSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteOrganizationCloseStage: {
            method: "DELETE",
            path: "/organizations/:organizationId/:closeStageId",
            pathParams: OrganizationCloseStagePathParamsSchema.merge(
                CloseStagePathParamsSchema,
            ),
            responses: {
                200: c.noBody(),
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        changeOrganizationCloseStagePosition: {
            method: "POST",
            path: "/organizations/:organizationId/:closeStageId/position",
            pathParams: OrganizationCloseStagePathParamsSchema.merge(
                CloseStagePathParamsSchema,
            ),
            body: OrganizationCloseStageChangePositionSchema,
            responses: {
                200: OrganizationCloseStageSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/organization-close-stages",
    },
);
